import React from 'react';
import CommonFileBody from '@rd-web-markets/shared/dist/folders_and_files/modal/CommonFileBody';
import TypeCheckboxes from './TypeCheckboxes';
export default props => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommonFileBody, props), /*#__PURE__*/React.createElement(TypeCheckboxes, {
    body: props.body,
    setBody: props.setBody,
    labelText: 'file_type',
    userClaimGroupAbilities: props.userClaimGroupAbilities
  }));
};